/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit'
import { getSuggestedUserList } from 'features/suggestedUsers/asyncThunks'
import * as API from '../../api'

export type SubscriberUserInfo = {
  dashboardId: number
  subscriber: { id: number; name: string }
}

export const getLiveReportId = createAsyncThunk(
  'liveReportConfig/getLiveReportId',
  async ({ dashboardId }: { dashboardId: number }) => {
    const response = await API.getLiveReportId(dashboardId)
    return response.data
  }
)

export const getLiveReportInfo = createAsyncThunk(
  'liveReportConfig/getLiveReportInfo',
  async ({ dashboardId }: { dashboardId: number }) => {
    const responseV4 = await API.getLiveReportInfo(dashboardId)

    if (!responseV4.data.liveReportEnabled) {
      const responseV3 = await API.getLiveReportInfo(dashboardId, 'V3')
      return {
        ...responseV3.data,
        liveReportEnabled: false
      }
    }
    return responseV4.data
  }
)

export const updateLiveReportStatus = createAsyncThunk(
  'liveReportConfig/updateLiveReportStatus',
  async (
    {
      dashboardId,
      liveReportInfo,
      accountId
    }: {
      dashboardId: number
      liveReportInfo: {
        liveReportEnabled: boolean
        anonymous: boolean
        liveReportId: string
        liveReportKey: string
        liveReportSubscribers: Array<{ id: number } | { id: number; name: string }>
      }
      accountId: number
    },
    { rejectWithValue, dispatch }
  ) => {
    try {
      const response = await API.updateLiveReportStatus(dashboardId, liveReportInfo)
      if (response.status === 200) {
        dispatch(getLiveReportId({ dashboardId }))
        dispatch(getLiveReportInfo({ dashboardId }))
        dispatch(getSuggestedUserList(accountId))
      }
      return response.data
    } catch (e: any) {
      console.error(e)
      return rejectWithValue(e.response.data)
    }
  }
)
